import { useTranslation } from '@splitfiesta/i18n';

interface AiTagProps {
  /** Defaults to "Filled in by AI". */
  a11yLabel?: string;
}

/** The "AI" pill after a field label the scan filled in. */
export function AiTag({ a11yLabel }: AiTagProps) {
  const { t } = useTranslation();
  return (
    <span
      role="img"
      aria-label={a11yLabel ?? t('expenses:scan.aiTagA11y')}
      className="inline-flex items-center rounded-full px-2 py-0.5 text-xs font-semibold leading-none bg-primary-50 text-primary-700 dark:bg-primary-500/15 dark:text-primary-300"
    >
      {t('expenses:scan.aiTag')}
    </span>
  );
}
